import classNames from "@calcom/ui/classNames";

export function Logo({
  small,
  icon,
  inline = true,
  className,
}: {
  small?: boolean;
  icon?: boolean;
  inline?: boolean;
  className?: string;
  /** @deprecated conservé pour compat d'appel — SETKA rend des assets statiques par thème */
  src?: string;
}) {
  // SETKA : logo par thème (transparent, pas de carré blanc, agrandi).
  // Clair = bleu #004d95, sombre = blanc → swap via dark:hidden / hidden dark:block.
  return (
    <h3 className={classNames("logo", inline && "inline", className)}>
      <strong>
        {icon ? (
          <>
            <img className="mx-auto w-11 dark:hidden" alt="Setka" title="Setka" src="/setka-symbol-color.svg" />
            <img
              className="mx-auto hidden w-11 dark:block"
              alt="Setka"
              title="Setka"
              src="/setka-symbol-white.svg"
            />
          </>
        ) : (
          <>
            {/* NB : `small` = pages d'accueil/auth (login, reset) → logo GRAND (h-16, ~64px) ;
                variante normale = header mobile / modales onboarding → h-10 (~40px). */}
            <img
              className={classNames(small ? "h-16 w-auto" : "h-10 w-auto", "dark:hidden")}
              alt="Setka"
              title="Setka"
              src="/setka-word-color.svg"
            />
            <img
              className={classNames(small ? "h-16 w-auto" : "h-10 w-auto", "hidden dark:block")}
              alt="Setka"
              title="Setka"
              src="/setka-word-white.svg"
            />
          </>
        )}
      </strong>
    </h3>
  );
}
